// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__dQQE1","sumupValues":"styles_sumupValues__1-zYl","lists":"styles_lists__2eVF-"};